import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Card, Spin, Input, Checkbox, DatePicker, Space, Select, Affix, Tooltip, Avatar, Row, Col, Typography, Divider, Table, message, InputNumber } from 'antd';
import { PhoneOutlined, MailOutlined, InfoCircleOutlined, DeleteOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import DynamicSelect from '../Record/DynamicSelectForLookup';
import Cookies from 'js-cookie';
import ApiService from '../Components/apiService'; // Import ApiService class
import { BASE_URL, DateFormat } from '../Components/Constant'; // Define the date format
import { useNavigate } from "react-router-dom";
import isEqual from "lodash/isEqual";


const { Option } = Select;
const { Title } = Typography;

const OrderScreen = ({
    selectedRecord,
    setSelectedDate,
    isFieldReadOnly
}) => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [lookupOptionforparent, setLookupOptionsForParent] = useState([]);
    const [orderLineItems, setOrderLineItems] = useState([]);
    const [batch, setBatch] = useState([]);
    const [packagedOutput, setPackagedOutput] = useState([]);
    const [fieldsData, setFieldsData] = useState([]);
    const [batchPackages, setBatchPackages] = useState([]);
    const [layout, setLayout] = useState(null);
    const security = useSelector(state => state.data.items[0]);
    const [currency, setCurrency] = useState('');
    const defaultCurrency = useSelector(state => state.data.orgItem);
    const currUserId = Cookies.get('userId');
    const currUserName = Cookies.get('name');
    const { id } = useParams();
    const [Orderdata, setOrderData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [orderForEdit, setOrderForEdit] = useState(null);
    const [orderLineItemForEdit, setOrderLineItemForEdit] = useState(null);
    const [savedRecord, setSavedRecord] = useState(false);
    const [RowWisePackages, setRowWisePackages] = useState({});
    const [LoadingPackages,setLoadingPackages] = useState(false);

    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true); // Start loading
    
            try {
                const baseFetches = [
                    fetchfields(),
                    fetchlayout(),
                    fetchBatches()
                ];
    
                const orderFetches = [];
    
                if (id) {
                    const fetchOrderDetails = async () => {
                        const OrderDetails = new ApiService(`${BASE_URL}/fetch_single_record/Order/${id}`, { "Content-Type": "application/json" }, 'GET');
                        const response = await OrderDetails.makeCall();
                        setOrderData(response);
                        setOrderForEdit(JSON.parse(JSON.stringify(response)));
                        setSavedRecord(true);
    
                        form.setFieldsValue(response);
                        form.setFieldValue('ShippingAddress_street', response?.ShippingAddress?.street);
                        form.setFieldValue('ShippingAddress_city', response?.ShippingAddress?.city);
                        form.setFieldValue('ShippingAddress_country', response?.ShippingAddress?.country);
                        form.setFieldValue('ShippingAddress_postalcode', response?.ShippingAddress?.postal_code);
                        form.setFieldValue('ShippingAddress_state', response?.ShippingAddress?.state);
    
                        form.setFieldValue('BillingAddress_street', response?.BillingAddress?.street);
                        form.setFieldValue('BillingAddress_city', response?.BillingAddress?.city);
                        form.setFieldValue('BillingAddress_country', response?.BillingAddress?.country);
                        form.setFieldValue('BillingAddress_postalcode', response?.BillingAddress?.postal_code);
                        form.setFieldValue('BillingAddress_state', response?.BillingAddress?.state);
                    };
    
                    const fetchOrderLineItems = async () => {
                        const orderLineItems = new ApiService(`${BASE_URL}/fetch_records_parent_childs/orderLineItem/Order_id/${id}`, {}, 'GET');
                        const response = await orderLineItems.makeCall();
    
                        response?.forEach(item => {
                            if (item.Batch_id) {
                                fetchPackagedOutput(item.Batch_id);
                            }
                        });
    
                        const updatedResponse = response.map((item, index) => ({
                            ...item,
                            key: index
                        }));
    
                        setOrderLineItems(updatedResponse);
                        setOrderLineItemForEdit(JSON.parse(JSON.stringify(updatedResponse)));
                    };
    
                    // Add both order-related fetches to be awaited
                    orderFetches.push(fetchOrderDetails(), fetchOrderLineItems());
                }
    
                // Wait for all fetches to finish
                await Promise.all([...baseFetches, ...orderFetches]);
            } catch (error) {
                console.error('Error while fetching data:', error);
            } finally {
                setLoading(false); // Done after everything finishes
            }
        };
    
        fetchAllData();
    }, [id]); 
    

    useEffect(() => {
        const value = {
            _id: currUserId,
            Name: currUserName,
        }
        form.setFieldsValue({ User: value });
    }, []);


    useEffect(() => {
        if (!id) {
            setOrderData(prevState => ({
                ...prevState,
                OrderDate: dayjs().format(DateFormat),
                OrderType: "Sales",
                Status: "Draft"
            }));

            form.setFieldValue('OrderType', "Sales");
            form.setFieldValue('Status', "Draft");
        }
    }, []);


    useEffect(() => {
        if (Orderdata?.CustomerVendor_id) {
            const fetchCustomerVendorDetails = async () => {
                try {
                    const customerVendorDetails = new ApiService(`${BASE_URL}/fetch_single_record/Account/${Orderdata?.CustomerVendor_id}`, { "Content-Type": "application/json" }, 'GET');
                    const response = await customerVendorDetails.makeCall();
                    setOrderData(prevState => ({
                        ...prevState,
                        BillingAddress: response?.BillingAddress
                    }));
                    form.setFieldValue('BillingAddress_street', response?.BillingAddress?.street);
                    form.setFieldValue('BillingAddress_city', response?.BillingAddress?.city);

                    form.setFieldValue('BillingAddress_country', response?.BillingAddress?.country);

                    form.setFieldValue('BillingAddress_postalcode', response?.BillingAddress?.postal_code);

                    form.setFieldValue('BillingAddress_state', response?.BillingAddress?.state);

                } catch (error) {
                    console.error('Error fetching customer vendor details:', error);
                }
            };
            fetchCustomerVendorDetails();
        }
    }, [Orderdata?.CustomerVendor_id])

    const fetchBatches = async () => {
        try {
            setLoading(true);
        
            const PackagedBatch = new ApiService(
                `${BASE_URL}/fetch_object_records`,
                { "Content-Type": "application/json" },
                "POST",
                {
                    object_name: "Batch",
                    filters: { Status: "Packaged" }
                }
            );
        
            const PartiallyBatch = new ApiService(
                `${BASE_URL}/fetch_object_records`,
                { "Content-Type": "application/json" },
                "POST",
                {
                    object_name: "Batch",
                    filters: { Status: "Partially Packaged" } // Adjust filter
                }
            );
        
            // Run both in parallel
            const [data, dataPartially] = await Promise.all([
                PackagedBatch.makeCall(),
                PartiallyBatch.makeCall()
            ]);
        
            // Combine both arrays
            const combinedData = [...data, ...dataPartially];
        
            setBatch(combinedData);
        } catch (error) {
            console.error("Error fetching batches:", error);
        } 
        

    }

    const fetchfields = async () => {
        try {
            setLoading(true);

            const apiService = new ApiService(`${BASE_URL}/mt_fields/object/Order`, {
                "Content-Type": "application/json",
            });

            const res = await apiService.makeCall();
            setFieldsData(res);

        }
        catch (error) {

        }

    }

    const fetchPackagedOutput = async (id) => {
        try {
            setLoadingPackages(true);
            const existingPackages = RowWisePackages[id];
            if (!existingPackages) {
            const getPackage = new ApiService(`${BASE_URL}/fetch_records_parent_childs/PacakgedOutput/Batch_id/${id}`, { 'Content-Type': 'application/json' }, 'GET');
            const responsePackage = await getPackage.makeCall();
            setPackagedOutput(responsePackage);

            setRowWisePackages(prev => ({
                ...prev,
                [id]: responsePackage
            }));

            setPackagedOutput(null);

            return responsePackage;
        }
        }
        catch (error) {

        }finally{
            setLoadingPackages(false);
        }
    }

    const fetchlayout = async () => {
        try {
            setLoading(true);

            const layouts = new ApiService(`${BASE_URL}/get_by_objectName/Order`, {}, 'GET');
            const res = await layouts.makeCall();
            const filteredLayout = res.filter(layout => layout.layout_name === "Order Screen Layout");
            setLayout(filteredLayout);

        }
        catch (error) {
            console.log(error);
        }
    }

    const fetchOrgSetupDetails = async () => {

        setCurrency(defaultCurrency?.currency);

    };

    useEffect(() => {
        fetchOrgSetupDetails();
    }, []);

    const handleCancel = () => {
        navigate(-1);
    };

    const handleSearch = async (value, fieldId, name, callback) => {
        const allFields = form.getFieldsValue();

        const filteredFields = Object.entries(allFields)
            .filter(([key, fieldValue]) => key !== name)
            .reduce((acc, [key, fieldValue]) => {
                acc[key] = fieldValue;
                return acc;
            }, {});
        if (value) {
            try {
                const apiService = new ApiService(`${BASE_URL}/search_lookup/${fieldId}/${value}`, {
                    'Content-Type': 'application/json', // Add any necessary headers, such as content type
                }, 'POST', { child_context: selectedRecord ? selectedRecord : filteredFields });
                const response = await apiService.makeCall();
                // Assuming the response data structure has options as an array
                setLookupOptionsForParent(prevOptions => ({
                    ...prevOptions,
                    [name]: response // Store the response for the specific field name
                }));
            } catch (error) {
                setLookupOptionsForParent(prevOptions => ({
                    ...prevOptions,
                    [name]: []
                }));
            } finally {
                callback();
            }
        } else {
            setLookupOptionsForParent(prevOptions => ({
                ...prevOptions,
                [name]: []
            }));
            callback();
        }
    };

    const renderFormItem = (field) => {

        const isDisable = !security?.object_settings?.["Order"]?.field_setting?.[field?.name]?.edit || (orderForEdit?.Status !== "Draft" && savedRecord);


        const isRequired = field?.required ? [{ required: true, message: `${field?.label} is required!` }] : [];

        // Check if help text is present for the field
        const renderLabel = (
            <span>
                {field?.label}
                {field?.help_text && field?.help_text.trim() !== "" && (
                    <Tooltip title={field?.help_text}>
                        <InfoCircleOutlined style={{ marginLeft: 8, color: '#1890ff' }} />
                    </Tooltip>
                )}
            </span>
        );

        switch (field?.type) {
            case 'string':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}
                    >
                        <Input
                            placeholder={`Enter ${field?.label}`}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'integer':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Input
                            type="number"
                            placeholder={`Enter ${field?.label}`}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'phone':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel} // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}


                    >
                        <Input
                            placeholder={`Enter ${field?.label}`}
                            addonBefore={
                                <PhoneOutlined style={{ cursor: 'pointer' }} />
                            }
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'email':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        style={{ width: "100%" }}

                        rules={[
                            { type: 'email', message: 'The input is not valid E-mail!' },
                            ...isRequired
                        ]}
                    >
                        <Input
                            type='email' prefix={<MailOutlined />}
                            placeholder="Enter email"
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'boolean':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        valuePropName="checked"
                        initialValue={false}
                        label={renderLabel}
                        style={{ width: "100%" }}

                    >
                        <Checkbox
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.checked
                                }));
                            }}
                        ></Checkbox>
                    </Form.Item>
                );

            case 'date':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Space>
                            <DatePicker
                                placeholder={`Select ${field?.label}`}
                                style={{ width: '100%' }}
                                format={DateFormat}
                                // disabled={isDisable}
                                value={
                                    field?.name === 'OrderDate'
                                        ? form.getFieldValue(field?.name)
                                            ? dayjs(form.getFieldValue(field?.name))
                                            : dayjs()
                                        : form.getFieldValue(field?.name)
                                            ? dayjs(form.getFieldValue(field?.name))
                                            : null
                                }
                                onChange={(date,dateString) => {
                                    form.setFieldsValue({ [field?.name]: date }); // ✅ Save raw date object
                                    console.log('date', dayjs(date,'DD/MM/YYYY'));
                                    setOrderData(prevState => ({
                                        ...prevState,
                                        [field?.name]: date ? dateString : null // Optional: ISO for backend
                                    }));
                                }}

                                disabled={isDisable}
                            />
                        </Space>
                    </Form.Item>
                );

            case 'datetime':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Space>
                            <DatePicker
                                showTime
                                placeholder={`Select ${field?.label}`}
                                style={{ width: '100%' }}
                                disabled={isDisable}
                                format="DD/MM/YYYY HH:mm A"
                                value={form.getFieldValue(field?.name) ? dayjs(form.getFieldValue(field?.name), "DD/MM/YYYY hh:mm A") : dayjs()}
                                onChange={(date, dateString) => {
                                    form.setFieldsValue({ [field?.name]: dateString });
                                    setOrderData(prevState => ({
                                        ...prevState,
                                        [field?.name]: dateString
                                    }));

                                }}
                            />
                        </Space>
                    </Form.Item>
                );

            case 'url':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        style={{ width: "100%" }}

                        rules={[
                            { type: 'url', message: 'Please enter a valid URL!' },
                            ...isRequired
                        ]}
                    >
                        <Input type="url"
                            placeholder={`Enter ${field?.label}`}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                            disabled={isDisable} />
                    </Form.Item>
                );

            case 'currency':
                const currencyDecimalPlacesBefore = field?.decimal_places_before;
                const currencyDecimalPlacesAfter = field?.decimal_places_after;
                const regexPattern = new RegExp(`^\\d{1,${currencyDecimalPlacesBefore}}(\\.\\d{0,${currencyDecimalPlacesAfter}})?$`);
                const handleCurrencyInput = (event) => {
                    const inputValue = event.target.value;
                    if (!regexPattern.test(inputValue)) {
                        event.preventDefault();
                    }
                };

                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Input
                            placeholder={`Enter ${field?.label}`}
                            onInput={handleCurrencyInput}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                            maxLength={currencyDecimalPlacesBefore + currencyDecimalPlacesAfter + 1}
                        />
                    </Form.Item>
                );

            case 'picklist':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}
                    >
                        <Select
                            placeholder={`Select ${field?.label}`}
                            allowClear
                            disabled={isDisable}
                            value={Orderdata?.[field?.name]?.trim()}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e
                                }));
                            }}
                        >
                            {field?.picklist_values.map((value) => (
                                <Select.Option key={value} value={value}>
                                    {value}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                );

            case 'multiselect':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Select
                            mode="multiple"
                            placeholder={`Select ${field?.label}`}
                            allowClear
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e
                                }));
                            }}
                        >
                            {field?.picklist_values.map((value) => (
                                <Select.Option key={value} value={value}>
                                    {value}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                );

            case 'lookup':
            return (
                <Form.Item
                    key={field?.name}
                    name={field?.name}
                    label={renderLabel}
                    rules={isRequired}
                    style={{ width: "100%" }}

                >
                    <DynamicSelect
                        objectName={field?.parent_object_name}
                        lookupConfig={field?.lookup_config}
                        onSearch={handleSearch}
                        value={form.getFieldValue(field?.name)}
                        name={field?.name}
                        lookupOptionforparent={lookupOptionforparent}
                        isFieldReadOnly={isFieldReadOnly}
                        fieldId={field?._id}
                        onChange={(newValue) => {
                            form.setFieldsValue({ [field?.name]: newValue })
                            setOrderData(prevState => ({
                                ...prevState,
                                [`${field?.name}_id`]: newValue
                            }));

                        }
                        } 
                        disabled={isDisable}
                    />
                </Form.Item>
            );

            case 'address':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={field?.label} // This shows "Address" as the label
                        style={{ width: "100%" }}
                    >
                        <Card title="Enter Address" bordered={true}>
                            <Form.Item
                                key={`${field?.name}_street`}
                                name={`${field?.name}_street`}
                                label="Street"
                                value={Orderdata?.[field?.name]?.street || ''}

                            >
                                <Input
                                    placeholder="Enter Street"
                                    disabled={isDisable}
                                    value={Orderdata?.[field?.name]?.street || ''}
                                    onChange={(e) => {
                                        setOrderData(prevState => ({
                                            ...prevState,
                                            [field?.name]: {
                                                ...prevState[field?.name], // Keep existing address fields
                                                "street": e.target.value   // Update only 'street'
                                            }
                                        }));
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field?.name}_city`}
                                name={`${field?.name}_city`}
                                label="City"
                            >
                                <Input
                                    placeholder="Enter City"
                                    disabled={isDisable}
                                    value={Orderdata?.[field?.name]?.city || ''}

                                    onChange={(e) => {
                                        setOrderData(prevState => ({
                                            ...prevState,
                                            [field?.name]: {
                                                ...prevState[field?.name], // Keep existing address fields
                                                "city": e.target.value   // Update only 'street'
                                            }
                                        }));
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field?.name}_state`}
                                name={`${field?.name}_state`}
                                label="State"
                            >
                                <Input
                                    placeholder="Enter State"
                                    disabled={isDisable}
                                    value={Orderdata?.[field?.name]?.state || ''}

                                    onChange={(e) => {
                                        setOrderData(prevState => ({
                                            ...prevState,
                                            [field?.name]: {
                                                ...prevState[field?.name], // Keep existing address fields
                                                "state": e.target.value   // Update only 'street'
                                            }
                                        }));
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field?.name}_country`}
                                name={`${field?.name}_country`}
                                label="Country"
                            >
                                <Input
                                    placeholder="Enter Country"
                                    disabled={isDisable}
                                    value={Orderdata?.[field?.name]?.country || ''}

                                    onChange={(e) => {
                                        setOrderData(prevState => ({
                                            ...prevState,
                                            [field?.name]: {
                                                ...prevState[field?.name], // Keep existing address fields
                                                "country": e.target.value   // Update only 'street'
                                            }
                                        }));
                                    }}
                                />
                            </Form.Item>
                            <Form.Item
                                key={`${field?.name}_postalcode`}
                                name={`${field?.name}_postalcode`}
                                label="Postal Code"
                            >
                                <Input
                                    placeholder="Enter Postal Code"
                                    disabled={isDisable}
                                    value={Orderdata?.[field?.name]?.postal_code || ''}
                                    onChange={(e) => {
                                        setOrderData(prevState => ({
                                            ...prevState,
                                            [field?.name]: {
                                                ...prevState[field?.name], // Keep existing address fields
                                                "postal_code": e.target.value   // Update only 'street'
                                            }
                                        }));
                                    }}
                                />
                            </Form.Item>
                        </Card>
                    </Form.Item>
                );

            case 'decimal':
                const decimalPlacesBefore = field?.decimal_places_before;
                const decimalPlacesAfter = field?.decimal_places_after;
                const decimalPattern = new RegExp(`^\\d{1,${decimalPlacesBefore}}(\\.\\d{0,${decimalPlacesAfter}})?$`);

                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Input
                            placeholder={`Enter ${field?.label}`}
                            maxLength={decimalPlacesBefore + decimalPlacesAfter + 1}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                            onInput={(e) => {
                                const value = e.target.value;
                                if (!decimalPattern.test(value)) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </Form.Item>
                );

            case 'percentage':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}
                        rules={isRequired}
                        style={{ width: "100%" }}

                    >
                        <Input
                            addonAfter="%"
                            type="float"
                            placeholder={`Enter ${field?.label}`}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'textarea':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        rules={isRequired}
                    >

                        <Input.TextArea
                            placeholder={`Enter ${field?.label}`}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'image':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}  // Use the custom label here
                        style={{ width: "100%" }}

                        rules={[
                            { type: 'url', message: 'Please enter a valid image URL!' },
                            ...isRequired
                        ]}
                    >
                        <Input type="url"
                            placeholder={`Enter ${field?.label} URL`}
                            disabled={isDisable}
                            onChange={(e) => {
                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: e.target.value
                                }));
                            }}
                        />
                    </Form.Item>
                );

            case 'richtext':
                return (
                    <Form.Item
                        key={field?.name}
                        name={field?.name}
                        label={renderLabel}
                        rules={isRequired}
                    >
                        <ReactQuill
                            value={form.getFieldValue(field?.name)}
                            onChange={(value) => {
                                form.setFieldsValue({ [field?.name]: value })

                                setOrderData(prevState => ({
                                    ...prevState,
                                    [field?.name]: value
                                }));

                            }
                            }
                            placeholder={`Enter ${field?.label}`}
                            disabled={isDisable}
                            theme="snow"
                            style={{ height: '200px', minHeight: '150px', paddingBottom: '40px', }}
                        />
                    </Form.Item>
                )

            default:
                return null;
        }
    };

    const addOrderLineItem = () => {
        setOrderLineItems([...orderLineItems, {
            key: orderLineItems.length,
            Batch_id: "",
            PackagingOutput_id: "",
            Quantity: "",
            Product_id: "",
            Discount:"",
            Tax:0.05,
            UnitPrice :"",
        }]);
        setBatchPackages(null);
    };

    const removeOrderLineItem = (key) => {
        const oli = orderLineItems?.filter((item) => item.key !== key);
        setOrderLineItems(orderLineItems?.filter((item) => item.key !== key));
    };

    const handleChange = (key, field, value) => {
        console.log('field', field,value);   
        if (field === "Batch_id") {
            const packages=fetchPackagedOutput(value);
            console.log('batch packages',packages);      
        }

        let updatedItem = {};

        if (field === "Quantity" || field === "UnitPrice" || field === "Discount") {
            updatedItem[field] = Number(value); // convert Quantity to a number
        }
         else {
            updatedItem[field] = value;
        }

        if (field === "PackagingOutput_id") {
            const Batch = orderLineItems[key]?.Batch_id
            const selectedPackagedOutput = Array.isArray(RowWisePackages[Batch])
            ? RowWisePackages[Batch].find(po => po?._id === value)
            : null;
            if (selectedPackagedOutput) {
                console.log('selectedPackagedOutput', selectedPackagedOutput?.Product);
                updatedItem["Product_id"] = selectedPackagedOutput?.Product?._id || "";
                updatedItem["UnitPrice"] = selectedPackagedOutput?.Product?.UnitPrice || "";

            }
        }

        setOrderLineItems(prev =>
            prev.map(item =>
                item.key === key ? { ...item, ...updatedItem } : item
            )
        );
    };

    const preventScroll = (event) => {
        event?.preventDefault();
    };

    const columns = [
        {
            title: "Select Batch",
            dataIndex: "Batch_id",
            render: (_, record) => (
                <Select
                    style={{ width: "170px" }} // Maximum width
                    onChange={(value) => handleChange(record.key, "Batch_id", value)}
                    value={record.Batch_id}
                >
                    {batch.map((batch) => (
                        <Option key={batch._id} value={batch._id}>
                            {batch.Name}
                        </Option>
                    ))}
                </Select>
            ),
        },
        {
            title: "Select Packaged Output",
            dataIndex: "PackagingOutput_id",
            render: (_, record) => {
                const currentBatchPackages = packagedOutput?.filter(
                    item => item?.Batch_id === record?.Batch_id
                );
                const bpacks=Array.isArray(RowWisePackages[record?.Batch_id]) &&
                RowWisePackages[record?.Batch_id]
                // If there's only one item, pre-select it
                const onlyOneOption = bpacks?.length === 1 ? bpacks[0]._id : undefined;

                // Use the already selected value in the record if available
                const selectedValue = record.PackagingOutput_id || onlyOneOption;

                if (!record.PackagingOutput_id && onlyOneOption) {
                    handleChange(record.key, "PackagingOutput_id", onlyOneOption);
                }

                return (
                    <Select
                        style={{ width: "150px" }}
                        value={selectedValue}
                        loading={LoadingPackages}
                        onChange={(value) =>
                            handleChange(record.key, "PackagingOutput_id", value)
                        }
                    >
                        {Array.isArray(RowWisePackages[record?.Batch_id]) &&
                        RowWisePackages[record?.Batch_id].map((po) => (
                            <Option key={po._id} value={po._id}>
                                {po.Name}
                            </Option>
                        ))}

                    </Select>
                );
            },
        },
        {
            title: "Product ",
            dataIndex: "Product_id",
            render: (_, record, key) => {
                const packaging = orderLineItems[key]?.PackagingOutput_id
                const selectedPackagedOutput = Array.isArray(RowWisePackages[record?.Batch_id])
                ? RowWisePackages[record?.Batch_id].find(po => po?._id === packaging)
                : null;
                              
                return (
                    <Input
                        style={{ width: "150px" }}
                        value={selectedPackagedOutput?.Product?.Name || null}
                        disabled

                    />
                );
            },
        },
        {
            title: "Packaging Product ",
            dataIndex: "PackagingProduct_id",
            render: (_, record, key) => {
                const packaging = orderLineItems[key]?.PackagingOutput_id
                const selectedPackagedOutput = Array.isArray(RowWisePackages[record?.Batch_id])
                ? RowWisePackages[record?.Batch_id].find(po => po?._id === packaging)
                : null;
                return (
                    <Input
                        style={{ width: "170px" }}
                        value={selectedPackagedOutput?.PackagingProduct?.Name || null}
                        disabled
                    />
                );
            },
        },
        {
            title: "Available Quantity",
            dataIndex: "available_quantity",
            render: (_, record, key) => {
                const packaging = orderLineItems[key]?.PackagingOutput_id
                const selectedPackagedOutput = Array.isArray(RowWisePackages[record?.Batch_id])
                ? RowWisePackages[record?.Batch_id].find(po => po?._id === packaging)
                : null;
                return (
                    <Input
                        style={{ width: "150px" }}
                        type="number"
                        value={selectedPackagedOutput?.AvailableQuantity || 0}
                        disabled
                        addonAfter={"Bags"}

                    />
                );
            },
        },
        {
            title: "Add Quantity",
            dataIndex: "Quantity",
            render: (_, record, key) => (
                <InputNumber
                    style={{ width: "150px" }} // Small width
                    value={record.Quantity}
                    onWheel={preventScroll}
                    disabled={savedRecord && orderForEdit?.Status !== "Draft"}
                    onChange={(e) => {
                        const packaging = orderLineItems[key]?.PackagingOutput_id
                        const selectedPackagedOutput = Array.isArray(RowWisePackages[record?.Batch_id])
                        ? RowWisePackages[record?.Batch_id].find(po => po?._id === packaging)
                        : null;                        
                        const matchingRecord = Array.isArray(orderLineItemForEdit)
                            ? orderLineItemForEdit.find(item => item._id === record._id)
                            : undefined;
                        const additionalQuantity = matchingRecord ? matchingRecord?.Quantity : 0;
                        if (orderForEdit?.Status === "Draft") {
                            if (Number(e) > extractNumericQuantity(selectedPackagedOutput?.AvailableQuantity) + additionalQuantity) {
                                message.warning("Quantity should not be greater than Available Quantity");
                                return;
                            }
                        } else {
                            if (!orderForEdit?.Status) {
                                if (Number(e) > extractNumericQuantity(selectedPackagedOutput?.AvailableQuantity)) {
                                    message.warning("Quantity should not be greater than Available Quantity");
                                    return;
                                }
                            }
                        }

                        handleChange(record.key, "Quantity", e)
                    }
                    }
                    addonAfter={"Bags"}
                />
            ),
        },
        {
            title:  "Discount",
            dataIndex: "Discount",
            render: (_, record, key) => {
                
                return (
                    <InputNumber
                        style={{ width: "150px" }}
                        value={record.Discount}
                        onChange={(e) => {
                            handleChange(record.key, "Discount", e)
                        }}
                        addonAfter={"%"}
                        onWheel={preventScroll}
                    />
                );
            },
        },
        {
            title: "Unit Price",
            dataIndex: "UnitPrice",
            render: (_, record, key) => {
                const packaging = orderLineItems[key]?.PackagingOutput_id
                const selectedPackagedOutput = Array.isArray(RowWisePackages[record?.Batch_id])
                ? RowWisePackages[record?.Batch_id].find(po => po?._id === packaging)
                : null;
                return (
                    <InputNumber
                        style={{ width: "150px" }}
                        value={record.UnitPrice}
                        onChange={(e) => {
                            handleChange(record.key, "UnitPrice", e)
                        }}
                        onWheel={preventScroll}

                    />
                );
            },
        },
        {
            title: "Action",
            dataIndex: "action",
            render: (_, record) => (
                <Tooltip title="Remove Item">
                    <Button
                        style={{ width: "40px" }} // Very small width
                        icon={<DeleteOutlined style={{ color: "red" }} />} // Red color icon
                        disabled={record?._id}
                        onClick={() => removeOrderLineItem(record.key)}
                    />
                </Tooltip>
            ),
        },
    ];

    const handleSave = async () => {
        console.log('order line item',orderLineItems);
        if (id) {
            try {
                setLoading(true);

                const changedValues = {};

                Object.keys(Orderdata).forEach((key) => {
                    const newValue = Orderdata[key];
                    const oldValue = orderForEdit[key];

                    const isNewKey = !(key in orderForEdit);
                    const isEmpty = newValue === "" || newValue === null || newValue === undefined;

                    if (!isEqual(newValue, oldValue)) {
                        // Include only if either:
                        // 1. It existed before and changed
                        // 2. It's a new key but the value is NOT empty
                        if (!isNewKey || (isNewKey && !isEmpty)) {
                            changedValues[key] = newValue;
                        }
                    }
                });

                changedValues['_id'] = orderForEdit?._id;

                const body = {
                    object_name: "Order",
                    data: changedValues
                };

                const apiService = new ApiService(
                    `${BASE_URL}/insert_or_update_records`,
                    { 'Content-Type': 'application/json' },
                    'POST',
                    body
                );

                const response = await apiService.makeCall();
                const filtered = orderLineItems?.map(({ Product, CreatedBy_id, LastModifiedBy_id, Order, CreatedBy, LastModifiedBy, User, Batch, key, OrderDate, deleted_at, Order_id, ...rest }) => ({
                    ...rest,
                    Order_id: Order_id ?? id,
                }));

                const bulkRecord = {
                    "object_name": "OrderLineItem",
                    "updates": filtered
                }

                const apiServiceforCreating = new ApiService(
                    `${BASE_URL}/bulk_upsert_records`,
                    { 'Content-Type': 'application/json' },
                    'POST',
                    bulkRecord
                );

                const respons = await apiServiceforCreating.makeCall();

                navigate(`/record/Order/${id}`);


            } catch (err) {
                const errorMessage = err && typeof err === 'object'
                    ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                    : 'Failed to update due to unknown error';
                message.error(errorMessage);

            }
            finally {
                setLoading(false);
            }

        } else {
            try {
                setLoading(true);

                console.log('order line item', orderLineItems);

                const body = {
                    object_name: "Order",
                    data: Orderdata
                }
                const apiService = new ApiService(
                    `${BASE_URL}/insert_or_update_records`,
                    { 'Content-Type': 'application/json' },
                    'POST',
                    body
                );

                const response = await apiService.makeCall();
                const orderid = response.id;
                message.success("Order created Successfully");

                const filtered = orderLineItems?.map(({ key, ...rest }) => rest);

                const updatedOrderlineitems = filtered?.map(item => ({
                    ...item,
                    Order_id: orderid
                }));


                const bulkRecord = {
                    object_name: "OrderLineItem",
                    records: updatedOrderlineitems
                }

                const apiServiceforCreating = new ApiService(
                    `${BASE_URL}/add_bulk_records`,
                    { 'Content-Type': 'application/json' },
                    'POST',
                    bulkRecord
                );
                const respons = await apiServiceforCreating.makeCall();
                message.success('Order line items are created successfully');

                navigate(`/record/Order/${orderid}`);

            }
            catch (err) {

                const errorMessage = err && typeof err === 'object'
                    ? Object.entries(err).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
                    : 'Failed to update due to unknown error';
                message.error(errorMessage);

            }
            finally {
                setLoading(false);
                setOrderLineItems(null);
                setOrderData(null);
                form.resetFields();

            }
        }

    }

    const extractNumericQuantity = (value) => {
        // Use regex to extract the numeric portion from a string
        const numericValue = parseFloat(value?.match(/[\d.]+/)?.[0]);
        return isNaN(numericValue) ? 0 : numericValue;
    };

    const handleSameAsBillingChange = (e) => {
            if (e.target.checked) {
                setOrderData(prevState => ({
                    ...prevState,
                    ShippingAddress: Orderdata?.BillingAddress
                }));
                form.setFieldValue('ShippingAddress_street', Orderdata?.BillingAddress?.street);
                form.setFieldValue('ShippingAddress_city', Orderdata?.BillingAddress?.city);
                form.setFieldValue('ShippingAddress_country', Orderdata?.BillingAddress?.country);
                form.setFieldValue('ShippingAddress_postalcode', Orderdata?.BillingAddress?.postal_code);
                form.setFieldValue('ShippingAddress_state', Orderdata?.BillingAddress?.state);
            } else {
                setOrderData(prevState => ({
                    ...prevState,
                    ShippingAddress: null
                }));
                form.setFieldValue('ShippingAddress_street', '');
                form.setFieldValue('ShippingAddress_city', '');
                form.setFieldValue('ShippingAddress_country', '');
                form.setFieldValue('ShippingAddress_postalcode', '');
                form.setFieldValue('ShippingAddress_state', '');
            }
        

    }

    return (
        <Spin spinning={loading} size="default">
            <Card
                title="Order Details"
                style={{ top: 0, padding: 0, maxWidth: "100%" }}
                bodyStyle={{ height: "100vh", overflow: "auto", width: "100%", padding: 0 }}
            >
                <Card
                    style={{
                        margin: '20px',
                        padding: '20px',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    }}
                    bodyStyle={{ padding: 0 }}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        style={{ fontSize: '16px' }}
                    >
                        <Row gutter={16}>
                            {
                                layout ? (
                                    layout[0]?.sections?.map((section, sectionIndex) => {
                                        const columnCount = section?.columns?.length || 2;
                                        const columnSpan = 24 / columnCount;
                                        return (
                                            <Col key={sectionIndex} span={24}>
                                                <div
                                                    style={{
                                                        border: '1px solid #ddd',
                                                        marginBottom: '20px',
                                                        padding: '20px',
                                                        borderRadius: '4px',
                                                        width: '100%',
                                                    }}
                                                >
                                                    <Title level={4} style={{ marginTop: '2px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        {section.name}

                                                        {section.name === 'Address Details' && (
                                                            <Checkbox onChange={handleSameAsBillingChange}>
                                                                Shipping Address same as Billing Address
                                                            </Checkbox>
                                                        )}
                                                    </Title>
                                                    <Row gutter={24} style={{ marginBottom: '0px' }}>
                                                        {section?.columns?.map((column, columnIndex) => {

                                                            return (
                                                                <Col key={columnIndex} span={columnSpan}>
                                                                    <div>
                                                                        {column.items?.map((item, rowIndex) => {
                                                                            const matchedField = fieldsData?.find(field => field?.name === item?.name);
                                                                            if (matchedField) {

                                                                                return (
                                                                                    item && (
                                                                                        <Form.Item
                                                                                            key={rowIndex}
                                                                                            style={{ marginBottom: '10px', padding: '0px' }}
                                                                                        >
                                                                                            {renderFormItem(matchedField)}
                                                                                        </Form.Item>
                                                                                    )
                                                                                );
                                                                            } return;
                                                                        })}
                                                                    </div>
                                                                </Col>
                                                            )
                                                        })}
                                                    </Row>
                                                </div>
                                            </Col>
                                        );
                                    })
                                ) : (
                                    <Col span={24}>
                                        <Row gutter={24} style={{ marginBottom: '0px' }}>
                                            
                                        </Row>
                                    </Col>
                                )
                            }
                        </Row>
                    </Form>
                </Card>
                <Divider></Divider>

                <Card title="Order Line Item">
                    <Button onClick={addOrderLineItem} style={{ marginBottom: '10px' }}>
                        Add Order Line Item
                    </Button>
                    <Table 
                    dataSource={orderLineItems} 
                    columns={columns} 
                    pagination={false} 
                    scroll={{ x: 'max-content' }} 
                    style={{ width: '100%' }}
                    />

                </Card>

                {(!savedRecord || orderForEdit?.Status === "Draft") && (
                    <Affix offsetBottom={50}>
                        <div style={{
                            width: '90%',
                            padding: '10px 0',
                            background: 'rgba(240, 242, 245, 0.9)', // Slightly transparent background
                            position: 'fixed',
                            bottom: '10px',
                            left: 110
                        }}>
                            <Row justify="center">
                                <Button onClick={handleCancel} style={{ marginRight: 8 }}>
                                    Cancel
                                </Button>
                                <Button type="primary" onClick={handleSave}>
                                    Save
                                </Button>
                            </Row>
                        </div>
                    </Affix>
                )}
            </Card>
         </Spin>

    );
};

export default OrderScreen;
